import FeedIcon from "@mui/icons-material/Feed";
import ListNews from "./List";
import CreateNews from "./Create";
import EditNews from "./Edit";
import ShowNews from "./Show";

//params
export const NEWS = "news";

//permissions

export const resources = {
  isMenu: true,
  icon: <FeedIcon />,
  name: NEWS,
  title: "Новини",
  list: <ListNews />,
  create: <CreateNews />,
  edit: <EditNews />,
  show: <ShowNews />,
  permission: "news",
};

//api url
